export default __webpack_public_path__ + "static/media/KR_Hero7_2.703beec0.png";